import { defaultDataTransformer } from '@aspectus/resource-commons';
import { createSender } from '@md/resources';
import { prefixAPI } from '@md/api';

export const contactResource = createSender(prefixAPI('/feedback/contact/create/'))
  .transform(defaultDataTransformer);
